const DAYS_LOOKBACK = 30;

/**
 * Computa alertas de Pulso Comercial Regional.
 * Muestra cada oportunidad interna reciente del OTRO país como card individual.
 *
 * Deduplicación: si hay múltiples sales con la misma empresa + campaña,
 * se muestra solo la de menor importe (las demás son versiones/duplicados).
 *
 * @param {Object} params
 * @param {string} params.miPais - País del usuario ("Chile" o "Perú")
 * @param {Array} params.clientesOtroPais - Clientes del otro país
 * @param {Array} params.salesOtroPais - Oportunidades (sales) del otro país
 * @returns {Array} Alertas ordenadas por fecha DESC
 */
export function computePulsoRegional({ miPais, clientesOtroPais, salesOtroPais }) {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - DAYS_LOOKBACK);

  const otroPais = miPais === "Chile" ? "Perú" : "Chile";

  // Mapa client_id → datos del cliente (otro país)
  const otroClienteMap = {};
  for (const c of clientesOtroPais) {
    otroClienteMap[c.id] = { empresa: (c.empresa || "").trim(), nombre: c.nombre || "" };
  }

  // Filtrar sales recientes no eliminadas
  const recientes = salesOtroPais.filter((sale) => {
    if (!sale.created_at || new Date(sale.created_at) < cutoff) return false;
    if (sale.eliminada) return false;
    return true;
  });

  // Deduplicar: misma empresa + misma campaña → quedarse con la de menor importe
  const dedupMap = {};
  for (const sale of recientes) {
    const clienteInfo = otroClienteMap[sale.client_id];
    const empresa = (clienteInfo?.empresa || sale.cliente || "").toLowerCase();
    const campana = (sale.campana || "").toLowerCase();
    const key = `${empresa}|${campana}`;

    if (!dedupMap[key] || (sale.importe || 0) < (dedupMap[key].importe || 0)) {
      dedupMap[key] = sale;
    }
  }

  // Convertir a alertas individuales
  return Object.values(dedupMap)
    .map((sale) => {
      const clienteInfo = otroClienteMap[sale.client_id];
      const empresa = clienteInfo?.empresa || sale.cliente || "Sin cliente";

      return {
        empresa,
        paisOrigen: otroPais,
        montoUSD: sale.moneda_dolar ? sale.importe || 0 : 0,
        montoLocal: sale.moneda_dolar ? 0 : sale.importe || 0,
        edificios: sale.edificiostotales || 0,
        fecha: sale.created_at,
        plazo: sale.periodopauta || 0,
        categoria: sale.campana || null,
        maxEstatus: parseInt(sale.estatus) || 0,
      };
    })
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
}
